import React from 'react';

export const MyMails: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="4 4 16 16" {...props}>
    <path d="M5 5h6v6H5z" fill="currentColor" />
    <path d="M13 13h6v6h-6z" fill="currentColor" />
    <path d="M13 6h5v5h-5z" fill="currentColor" />
    <path d="M6 13h5v5H6z" fill="currentColor" />
  </svg>
);
